import React from 'react';
import { Form, Header, Segment, Loader, Icon, Popup, Table, Message, Grid, Button } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';

import ReactExport from 'react-data-export';
import SearchTableData from '../util/SearchTableData';
import { sanitizeExcelDataSet } from '../util/sanitizeExcel';
import { IconHeader } from '../Assets/util/css';
import { fetchAcademicYears } from '../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

const parseId = value => {
    const parsedValue = parseInt(value, 10);
    return Number.isNaN(parsedValue) ? '' : parsedValue;
};

const hasId = value => value !== '' && value !== null && value !== undefined;

const firstAvailableId = (...values) => values.find(value => hasId(value)) || '';

const capitalizeFirstLetter = value => {
    if (!value) {
        return '';
    }

    return value.charAt(0).toUpperCase() + value.slice(1);
};

const getStudentStudyProgram = item => item &&
    item.thesisPresentation &&
    item.thesisPresentation.thesis &&
    item.thesisPresentation.thesis.studentStudyProgram
    ? item.thesisPresentation.thesis.studentStudyProgram
    : null;

const hasGraduationDate = item => {
    const studentStudyProgram = getStudentStudyProgram(item);
    return !!(studentStudyProgram && (studentStudyProgram.graduationDate || studentStudyProgram.graduation_date));
};

const thesisDefenseMarkMessageIds = {
    successfully_defended: 'mentorships.successfullyDefended',
    uo: 'mentorships.successfullyDefended',
    six: 'mentorships.successfullyDefended',
    seven: 'mentorships.successfullyDefended',
    eight: 'mentorships.successfullyDefended',
    nine: 'mentorships.successfullyDefended',
    ten: 'mentorships.successfullyDefended',
    not_defended: 'mentorships.notDefended',
    no: 'mentorships.notDefended',
    five: 'mentorships.notDefended',
    did_not_attend: 'mentorships.didNotAttend',
    not_attended: 'mentorships.didNotAttend',
    na: 'mentorships.didNotAttend'
};

class Mentorships extends React.Component {
    constructor(props) {
        super(props);

        let storedAcademicYearId = '';
        let storedId = '';
        let storedOrganizationalUnitId = '';

        if (localStorage.getItem('academicYearId')) {
            storedAcademicYearId = parseId(localStorage.getItem('academicYearId'));
        }

        storedId = firstAvailableId(
            parseId(localStorage.getItem('id')),
            parseId(localStorage.getItem('employeeId'))
        );

        if (localStorage.getItem('orgUnit')) {
            storedOrganizationalUnitId = parseId(localStorage.getItem('orgUnit'));
        } else if (localStorage.getItem('organizationalUnitId')) {
            storedOrganizationalUnitId = parseId(localStorage.getItem('organizationalUnitId'));
        }

        if (props.location && props.location.state) {
            storedId = firstAvailableId(parseId(props.location.state.id), storedId);
            storedOrganizationalUnitId = firstAvailableId(
                parseId(props.location.state.organizationalUnitId),
                storedOrganizationalUnitId
            );
        }

        this.state = {
            academicYears: [],
            academicYearId: storedAcademicYearId,

            professorThesisRoles: [],
            selectedProfessorThesisRoleId: '',

            thesisMentorships: [],
            filteredMentorships: [],
            results: [],
            excelData: [],

            loaded: false,
            loadedYears: false,
            loadedRoles: false,
            id: storedId,
            organizationalUnitId: storedOrganizationalUnitId,
            error: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchLookups = this.fetchLookups.bind(this);
        this.fetchMentorships = this.fetchMentorships.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        this.getAcademicYearIdFromItem = this.getAcademicYearIdFromItem.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.buildExcelData = this.buildExcelData.bind(this);
        this.isProfessorRole = this.isProfessorRole.bind(this);
        this.requiresOrganizationalUnitParam = this.requiresOrganizationalUnitParam.bind(this);
        this.getRoleId = this.getRoleId.bind(this);
        this.getRoleName = this.getRoleName.bind(this);
        this.getThesisPresentationMarkName = this.getThesisPresentationMarkName.bind(this);
    }

    componentDidMount() {
        if (this.props.location.state) {
            const employeeId = parseId(this.props.location.state.id);

            localStorage.setItem('id', employeeId);
            localStorage.setItem('employeeId', employeeId);
        }

        axios.all([fetchAcademicYears()])
            .then(axios.spread((res) => {
                const academicYears = res.data.reverse().map(el => ({
                    ...el,
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));

                this.setState({
                    academicYears,
                    loadedYears: true
                });

                let selectedId = this.state.academicYearId;

                if (!selectedId) {
                    axios.get('/academic-years/current')
                        .then(currentRes => {
                            selectedId = currentRes.data.id;

                            const selectedYear = academicYears.find(el => el.value === selectedId);

                            this.setState({ academicYearId: selectedId }, () => {
                                localStorage.setItem('academicYearId', selectedId);
                                localStorage.setItem('academicYearText', selectedYear ? selectedYear.text : '');
                                this.fetchLookups();
                            });
                        })
                        .catch(() => {
                            this.fetchLookups();
                        });
                } else {
                    const selectedYear = academicYears.find(el => el.value === selectedId);
                    localStorage.setItem('academicYearText', selectedYear ? selectedYear.text : '');
                    this.fetchLookups();
                }
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch academic years', err);
            });
    }

    isProfessorRole() {
        const activeRole = localStorage.getItem('activeRole') || '';
        return activeRole.startsWith('Profesor:') || activeRole.startsWith('Asistent:');
    }

    requiresOrganizationalUnitParam() {
        const activeRole = localStorage.getItem('activeRole') || '';
        return activeRole === 'AIDA' ||
            activeRole === 'Administrator' ||
            activeRole.substr(0, 38) === 'Služba za nastavu i studentska pitanja';
    }

    fetchLookups() {
        axios.get('/professor-thesis-roles')
            .then(roleRes => {
                const professorThesisRoles = roleRes.data.map(el => ({
                    ...el,
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));

                this.setState({
                    professorThesisRoles,
                    loadedRoles: true
                }, () => this.fetchMentorships());
            })
            .catch(err => {
                console.error('Failed to fetch lookups:', err);
                this.setState({ error: true, loaded: true });
            });
    }

    fetchMentorships() {
        const employeeId = firstAvailableId(
            this.state.id,
            parseId(localStorage.getItem('id')),
            parseId(localStorage.getItem('employeeId'))
        );
        const organizationalUnitId = firstAvailableId(
            this.state.organizationalUnitId,
            parseId(localStorage.getItem('orgUnit')),
            parseId(localStorage.getItem('organizationalUnitId'))
        );
        const isProfessor = this.isProfessorRole();

        if (!isProfessor && !employeeId) {
            this.setState({
                thesisMentorships: [],
                filteredMentorships: [],
                results: [],
                excelData: [],
                loaded: true
            });
            return;
        }

        if (!isProfessor && this.requiresOrganizationalUnitParam() && !hasId(organizationalUnitId)) {
            this.setState({
                thesisMentorships: [],
                filteredMentorships: [],
                results: [],
                excelData: [],
                loaded: true,
                error: true
            });
            return;
        }

        this.setState({ loaded: false });

        const url = isProfessor
            ? '/professor/thesis-presentation-professors/employee/'
            : `/professor/thesis-presentation-professors/employee/${employeeId}/`;

        const config = !isProfessor && hasId(organizationalUnitId)
            ? { params: { organizationalUnitId } }
            : {};

        axios.get(url, config)
            .then(res => {
                const thesisMentorships = res.data || [];

                this.setState({
                    thesisMentorships,
                    loaded: true,
                    results: []
                }, this.applyFilters);
            })
            .catch(err => {
                console.log('Failed to fetch thesis mentorships', err);
                this.setState({
                    thesisMentorships: [],
                    filteredMentorships: [],
                    results: [],
                    excelData: [],
                    loaded: true,
                    error: true
                });
            });
    }

    getAcademicYearIdFromItem(item) {
        try {
            if (
                item &&
                item.thesisPresentation &&
                item.thesisPresentation.thesis &&
                item.thesisPresentation.thesis.studentStudyProgram &&
                item.thesisPresentation.thesis.studentStudyProgram.gradStudentAcademicYear &&
                item.thesisPresentation.thesis.studentStudyProgram.gradStudentAcademicYear.id
            ) {
                return item.thesisPresentation.thesis.studentStudyProgram.gradStudentAcademicYear.id;
            }

            if (
                item &&
                item.thesisPresentation &&
                item.thesisPresentation.thesis &&
                item.thesisPresentation.thesis.studentStudyProgram &&
                item.thesisPresentation.thesis.studentStudyProgram.studyProgram &&
                item.thesisPresentation.thesis.studentStudyProgram.studyProgram.academicYearStart &&
                item.thesisPresentation.thesis.studentStudyProgram.studyProgram.academicYearStart.id
            ) {
                return item.thesisPresentation.thesis.studentStudyProgram.studyProgram.academicYearStart.id;
            }

            return null;
        } catch (e) {
            return null;
        }
    }

    getRoleId(item) {
        return item && item.role && item.role.id ? item.role.id : item.roleId;
    }

    getRoleName(item) {
        let roleName = '';

        if (item && item.role && item.role.name) {
            roleName = item.role.name;
        } else {
            roleName = item && item.roleName ? item.roleName : '';
        }

        return capitalizeFirstLetter(roleName);
    }

    getThesisPresentationMarkName(item) {
        const mark = item ? item.mark : null;

        if (!mark) {
            return '';
        }

        const markKey = mark._key || mark.key_ || mark.key;
        const messageId = thesisDefenseMarkMessageIds[markKey];

        if (messageId) {
            return this.props.intl.formatMessage({ id: messageId });
        }

        if (mark.passed === true) {
            return this.props.intl.formatMessage({ id: 'mentorships.successfullyDefended' });
        }

        if (mark.passed === false) {
            return this.props.intl.formatMessage({ id: 'mentorships.notDefended' });
        }

        if (mark.number && parseInt(mark.number, 10) >= 6) {
            return this.props.intl.formatMessage({ id: 'mentorships.successfullyDefended' });
        }

        if (mark.number && parseInt(mark.number, 10) < 6) {
            return this.props.intl.formatMessage({ id: 'mentorships.notDefended' });
        }

        return mark.displayName || mark.name || '';
    }

    buildExcelData(data) {
        const excelData = data.map(el => {
            const englishTranslation = el.thesisPresentation &&
            el.thesisPresentation.thesis &&
            el.thesisPresentation.thesis.translations &&
            el.thesisPresentation.thesis.translations.length
                ? el.thesisPresentation.thesis.translations.find(t => t.language === 'en')
                : null;

            const studentName = el.thesisPresentation &&
            el.thesisPresentation.thesis &&
            el.thesisPresentation.thesis.studentStudyProgram &&
            el.thesisPresentation.thesis.studentStudyProgram.student
                ? `${el.thesisPresentation.thesis.studentStudyProgram.student.firstName || ''} ${el.thesisPresentation.thesis.studentStudyProgram.student.lastName || ''}`
                : '';

            const studyProgram = el.thesisPresentation &&
            el.thesisPresentation.thesis &&
            el.thesisPresentation.thesis.studentStudyProgram &&
            el.thesisPresentation.thesis.studentStudyProgram.studyProgram
                ? `${el.thesisPresentation.thesis.studentStudyProgram.studyProgram.studyProgramBasic.name} - ${el.thesisPresentation.thesis.studentStudyProgram.studyProgram.name}`
                : '';

            const academicYear = el.thesisPresentation &&
            el.thesisPresentation.thesis &&
            el.thesisPresentation.thesis.studentStudyProgram &&
            el.thesisPresentation.thesis.studentStudyProgram.gradStudentAcademicYear
                ? el.thesisPresentation.thesis.studentStudyProgram.gradStudentAcademicYear.name
                : '';

            const approvalDate = el.thesisPresentation &&
            el.thesisPresentation.thesis &&
            el.thesisPresentation.thesis.themeApprovalDecisionDate
                ? moment(el.thesisPresentation.thesis.themeApprovalDecisionDate).format('D. M. YYYY.')
                : '';

            const defenseDate = el.thesisPresentation && el.thesisPresentation.date
                ? moment(el.thesisPresentation.date).format('D. M. YYYY.')
                : '';

            return [
                { value: this.getRoleName(el) },
                { value: studentName },
                { value: studyProgram },
                { value: el.thesisPresentation && el.thesisPresentation.thesis && el.thesisPresentation.thesis.theme ? el.thesisPresentation.thesis.theme : '' },
                { value: englishTranslation && englishTranslation.theme ? englishTranslation.theme : '' },
                { value: academicYear },
                { value: approvalDate ? `${defenseDate}\n${approvalDate}` : defenseDate },
                { value: this.getThesisPresentationMarkName(el) }
            ];
        });

        this.setState({ excelData });
    }

    applyFilters() {
        const { thesisMentorships, academicYearId, selectedProfessorThesisRoleId } = this.state;

        let filteredMentorships = [...thesisMentorships];

        if (academicYearId) {
            filteredMentorships = filteredMentorships.filter(item => {
                const itemAcademicYearId = this.getAcademicYearIdFromItem(item);
                return parseInt(itemAcademicYearId, 10) === parseInt(academicYearId, 10);
            });
        }

        if (selectedProfessorThesisRoleId) {
            filteredMentorships = filteredMentorships.filter(item =>
                this.getRoleId(item) && parseInt(this.getRoleId(item), 10) === parseInt(selectedProfessorThesisRoleId, 10));
        }

        this.setState({
            filteredMentorships,
            results: []
        }, () => this.buildExcelData(filteredMentorships));
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        }, () => {
            if (name === 'academicYearId') {
                localStorage.setItem('academicYearId', value || '');

                const selectedYear = this.state.academicYears.find(el => el.value === value);
                localStorage.setItem('academicYearText', selectedYear ? selectedYear.text : '');
            }

            this.applyFilters();
        });
    }

    getResults(results) {
        this.setState({ results }, () => this.buildExcelData(results));
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.filteredMentorships;
    }

    render() {
        const { intl } = this.props;
        const dataToRender = this.getDataToRender();

        const multiDataSet = [
            {
                columns: [
                    { title: intl.formatMessage({ id: 'mentorships.role' }), width: { wpx: 180 } },
                    { title: intl.formatMessage({ id: 'mentorships.studentName' }), width: { wpx: 220 } },
                    { title: intl.formatMessage({ id: 'mentorships.studyProgram' }), width: { wpx: 220 } },
                    { title: intl.formatMessage({ id: 'mentorships.thesisTopic' }), width: { wpx: 300 } },
                    { title: intl.formatMessage({ id: 'mentorships.thesisTopicEn' }), width: { wpx: 300 } },
                    { title: intl.formatMessage({ id: 'mentorships.academicYear' }), width: { wpx: 140 } },
                    { title: `${intl.formatMessage({ id: 'mentorships.defenseDate' })} / ${intl.formatMessage({ id: 'mentorships.themeApprovalDate' })}`, width: { wpx: 180 } },
                    { title: intl.formatMessage({ id: 'mentorships.grade' }), width: { wpx: 120 } }
                ],
                data: this.state.excelData
            }
        ];

        return (
            <div>
                <Header as="h1">
                    <FormattedMessage id="mentorships.title" />
                </Header>

                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3">
                            <FormattedMessage id="mentorships.overview" />
                            <Header style={IconHeader} floated="right">
                                <Icon />
                                {(localStorage.getItem('activeRole').substr(0, 10) === 'Studentska' ||
                                    localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu') && (
                                    <Popup
                                        trigger={
                                            <Icon
                                                link
                                                circular
                                                basic="true"
                                                floated="right"
                                                name="arrow left"
                                                onClick={() => window.history.go(-1)}
                                            />
                                        }
                                        content={<FormattedMessage id="common.back" />}
                                        hideOnScroll
                                        position="top center"
                                    />
                                )}
                            </Header>
                        </Header>
                    </Segment>

                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field disabled={!this.state.loadedYears}>
                                    <label><FormattedMessage id="common.academicYear" /></label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder={intl.formatMessage({ id: 'mentorships.selectAcademicYear' })}
                                        value={this.state.academicYearId}
                                        onChange={this.handleInputChange}
                                        name="academicYearId"
                                        options={this.state.academicYears}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>

                                <Form.Field disabled={!this.state.loadedRoles}>
                                    <label><FormattedMessage id="mentorships.role" /></label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder={intl.formatMessage({ id: 'mentorships.selectRole' })}
                                        value={this.state.selectedProfessorThesisRoleId}
                                        onChange={this.handleInputChange}
                                        name="selectedProfessorThesisRoleId"
                                        options={this.state.professorThesisRoles}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>

                        {!this.state.loaded ? (
                            <div style={{ paddingTop: '100px', paddingBottom: '100px' }}>
                                <Loader active />
                            </div>
                        ) : (
                            <div>
                                {this.state.error && (
                                    <Message negative>
                                        <FormattedMessage id="common.error" />
                                    </Message>
                                )}

                                {dataToRender.length ? (
                                    <Table celled selectable compact>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell colSpan={8}>
                                                    <Grid columns={2} stackable>
                                                        <Grid.Column width={14}>
                                                            <SearchTableData
                                                                profMozilla
                                                                data={this.state.filteredMentorships}
                                                                getResults={this.getResults}
                                                                disabled={false}
                                                                filterItem={[
                                                                    'role.name',
                                                                    'thesisPresentation.thesis.theme',
                                                                    'thesisPresentation.thesis.studentStudyProgram.student.firstName',
                                                                    'thesisPresentation.thesis.studentStudyProgram.student.lastName',
                                                                    'thesisPresentation.thesis.studentStudyProgram.studyProgram.name'
                                                                ]}
                                                            />
                                                        </Grid.Column>

                                                        <Grid.Column width={2} textAlign="center">
                                                            <ExcelFile
                                                                filename={intl.formatMessage({ id: 'mentorships.excelFileName' })}
                                                                element={
                                                                    <Popup
                                                                        trigger={
                                                                            <Button
                                                                                animated="vertical"
                                                                                color="green"
                                                                                basic
                                                                                floated="right"
                                                                                fluid
                                                                                style={{ textAlign: 'center' }}
                                                                            >
                                                                                <Button.Content hidden>
                                                                                    <Icon name="download" />
                                                                                </Button.Content>
                                                                                <Button.Content visible>
                                                                                    Excel
                                                                                </Button.Content>
                                                                            </Button>
                                                                        }
                                                                        content={intl.formatMessage({ id: 'mentorships.downloadExcel' })}
                                                                        hideOnScroll
                                                                        position="top center"
                                                                    />
                                                                }
                                                            >
                                                                <ExcelSheet
                                                                    dataSet={sanitizeExcelDataSet(multiDataSet)}
                                                                    name={intl.formatMessage({ id: 'mentorships.excelSheetName' })}
                                                                />
                                                            </ExcelFile>
                                                        </Grid.Column>
                                                    </Grid>
                                                </Table.HeaderCell>
                                            </Table.Row>

                                            <Table.Row>
                                                <Table.HeaderCell><FormattedMessage id="mentorships.role" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="mentorships.studentName" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="mentorships.studyProgram" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="mentorships.thesisTopic" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="mentorships.thesisTopicEn" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="mentorships.academicYear" /></Table.HeaderCell>
                                                <Table.HeaderCell>
                                                    <FormattedMessage id="mentorships.defenseDate" />
                                                    <br />
                                                    <span style={{ color: 'grey' }}>
                                                        <FormattedMessage id="mentorships.themeApprovalDate" />
                                                    </span>
                                                </Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="mentorships.grade" /></Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>

                                        <Table.Body>
                                            {dataToRender.map((el, index) => {
                                                const englishTranslation = el.thesisPresentation &&
                                                el.thesisPresentation.thesis &&
                                                el.thesisPresentation.thesis.translations &&
                                                el.thesisPresentation.thesis.translations.length
                                                    ? el.thesisPresentation.thesis.translations.find(t => t.language === 'en')
                                                    : null;

                                                return (
                                                    <Table.Row key={index}>
                                                        <Table.Cell verticalAlign="middle">
                                                            {this.getRoleName(el)}
                                                        </Table.Cell>

                                                        <Table.Cell verticalAlign="middle">
                                                            {el.thesisPresentation &&
                                                            el.thesisPresentation.thesis &&
                                                            el.thesisPresentation.thesis.studentStudyProgram &&
                                                            el.thesisPresentation.thesis.studentStudyProgram.student
                                                                ? `${el.thesisPresentation.thesis.studentStudyProgram.student.firstName || ''} ${el.thesisPresentation.thesis.studentStudyProgram.student.lastName || ''}`
                                                                : ''}
                                                            {hasGraduationDate(el) && (
                                                                <Popup
                                                                    trigger={(
                                                                        <Icon
                                                                            name="student"
                                                                            color="blue"
                                                                            style={{ marginLeft: '6px' }}
                                                                        />
                                                                    )}
                                                                    content="Diplomiran student"
                                                                    hideOnScroll
                                                                    position="top center"
                                                                />
                                                            )}
                                                        </Table.Cell>

                                                        <Table.Cell verticalAlign="middle">
                                                            {el.thesisPresentation &&
                                                            el.thesisPresentation.thesis &&
                                                            el.thesisPresentation.thesis.studentStudyProgram &&
                                                            el.thesisPresentation.thesis.studentStudyProgram.studyProgram &&
                                                            el.thesisPresentation.thesis.studentStudyProgram.studyProgram.studyProgramBasic
                                                                ? el.thesisPresentation.thesis.studentStudyProgram.studyProgram.studyProgramBasic.name
                                                                : ''}
                                                            {' - '}
                                                            {el.thesisPresentation &&
                                                            el.thesisPresentation.thesis &&
                                                            el.thesisPresentation.thesis.studentStudyProgram &&
                                                            el.thesisPresentation.thesis.studentStudyProgram.studyProgram
                                                                ? el.thesisPresentation.thesis.studentStudyProgram.studyProgram.name
                                                                : ''}
                                                        </Table.Cell>

                                                        <Table.Cell verticalAlign="middle">
                                                            {el.thesisPresentation &&
                                                            el.thesisPresentation.thesis &&
                                                            el.thesisPresentation.thesis.theme
                                                                ? el.thesisPresentation.thesis.theme
                                                                : ''}
                                                        </Table.Cell>

                                                        <Table.Cell verticalAlign="middle">
                                                            {englishTranslation && englishTranslation.theme
                                                                ? englishTranslation.theme
                                                                : ''}
                                                        </Table.Cell>

                                                        <Table.Cell verticalAlign="middle">
                                                            {el.thesisPresentation &&
                                                            el.thesisPresentation.thesis &&
                                                            el.thesisPresentation.thesis.studentStudyProgram &&
                                                            el.thesisPresentation.thesis.studentStudyProgram.gradStudentAcademicYear
                                                                ? el.thesisPresentation.thesis.studentStudyProgram.gradStudentAcademicYear.name
                                                                : ''}
                                                        </Table.Cell>

                                                        <Table.Cell verticalAlign="middle">
                                                            {el.thesisPresentation && el.thesisPresentation.date
                                                                ? moment(el.thesisPresentation.date).format('D. M. YYYY.')
                                                                : ''}
                                                            <br />
                                                            <span style={{ color: 'grey' }}>
                                                                {el.thesisPresentation &&
                                                                el.thesisPresentation.thesis &&
                                                                el.thesisPresentation.thesis.themeApprovalDecisionDate
                                                                    ? moment(el.thesisPresentation.thesis.themeApprovalDecisionDate).format('D. M. YYYY.')
                                                                    : ''}
                                                            </span>
                                                        </Table.Cell>

                                                        <Table.Cell verticalAlign="middle">
                                                            {this.getThesisPresentationMarkName(el)}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                );
                                            })}
                                        </Table.Body>
                                    </Table>
                                ) : (
                                    <p><FormattedMessage id="mentorships.noData" /></p>
                                )}
                            </div>
                        )}
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}

export default injectIntl(Mentorships);



// WEBPACK FOOTER //
// ./src/views/Professor/Mentorships.js